import React from "react";
import Helmet from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";

export default (props) => {
    const data = useStaticQuery(graphql`
        query SiteTitleQuery {
            site {
                siteMetadata {
                    title,
                    description,
                    image
                }
            }
        }
    `);

    return (
        <Helmet
            defaultTitle={ data.site.siteMetadata.title }
            titleTemplate="%s - Glee"
            title={ props.title }
            meta={[
                {
                    name: "robots",
                    content: props.robots || "noodp",
                },
                {
                    name: "twitter:title",
                    property: "og:title",
                    content: props.title || data.site.siteMetadata.title,
                },
                {
                    name: "description",
                    content: props.description || data.site.siteMetadata.description,
                },
                {
                    name: "twitter:description",
                    property: "og:description",
                    content: props.description || data.site.siteMetadata.description,
                },
                {
                    name: "twitter:image",
                    property: "og:image",
                    content: props.image || data.site.siteMetadata.image,
                }
            ]}
        />
    );
};
